import { withUiResources } from '@felix/ui';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from './locales/en.js';
import { tr } from './locales/tr.js';

export const LANGUAGES = ['en', 'tr'] as const;
export type Language = (typeof LANGUAGES)[number];
const STORAGE_KEY = 'felix.language';

/** Seçilen dil; yoksa tarayıcı Türkçe ise TR, değilse İngilizce (varsayılan; CLAUDE.md "i18n"). */
export function initialLanguage(stored: string | null, browser: readonly string[]): Language {
  if (stored === 'en' || stored === 'tr') return stored;
  return browser.some((language) => language.toLowerCase().startsWith('tr')) ? 'tr' : 'en';
}

export function setupI18n(): typeof i18next {
  let stored: string | null = null;
  try {
    stored = localStorage.getItem(STORAGE_KEY);
  } catch {
    stored = null;
  }
  const lng = initialLanguage(stored, navigator.languages ?? [navigator.language]);
  void i18next.use(initReactI18next).init({
    resources: {
      en: { translation: withUiResources('en', en) },
      tr: { translation: withUiResources('tr', tr) },
    },
    lng,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });
  document.documentElement.lang = lng;
  i18next.on('languageChanged', (language) => {
    document.documentElement.lang = language;
    try {
      localStorage.setItem(STORAGE_KEY, language);
    } catch {
      // Gizli pencerede depolama olmayabilir; dil yalnız bu oturumda kalır
    }
  });
  return i18next;
}
